import React, { useEffect, useRef, useState } from "react";
import TopContainer from "../CustomComponent/TopContainer";
import "../../../Css/Registered Users/registeredUsers.css";
import "../../../Css/Registered Users/registeredUsersSingle.css";
import AvatarImg from "../../../Assets/Images/man.jpg";
import { Dialog, IconButton, Tooltip } from "@mui/material";
import VisibilityOutlined from "@mui/icons-material/VisibilityOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { useNavigate, useParams } from "react-router-dom";
import {
  balancePaymentAPICall,
  getSingleCustomer,
  resetPasswordAPICall,
  suspendUserApiCall,
  viewInvoiceOfCustomer,
  renewPackageManualAPICall,
  renewBranchManualAPICall,
  adjustLicenseAPICall,
  payLicenseBalanceAPICall,
  deleteLicenseHistoryAPICall,
} from "../../../API/RegisterdUsers/RegisterdUsersApi";
import { useSelector } from "react-redux";
import printImage from "../../../Assets/Images/invoice2.svg";
import { Invoice } from "./Invoice";
import ReactToPrint from "react-to-print";
import { PrintOutlined } from "@mui/icons-material";
import textileImg from "../../../Assets/Icons/sewing-machine_2_.svg";
import { LoadingForm } from "../../Custom Components/LoadingForm";
import invoice from "../../../Assets/Images/Group 16831.png";
import { currentTime, today } from "../../../Functions/Date";
import SuccessSnackbar from "../../SingleCompoents/SnackBars/SuccessSnackbar";
import ErrorSnackbar from "../../SingleCompoents/SnackBars/ErrorSnackbar";

const RegisteredUserSingle = () => {
  let invoicePrint = useRef();
  let navigate = useNavigate();
  const singleViewId = localStorage.getItem("singleViewId");
  const getSingleCustomers = useSelector((state) => state.registerdUsers.singleUserData);
  const invoiceData = useSelector((state) => state.registerdUsers.customerInvoice);
  const options = [{ type: "Textile" }, { type: "Restaurant" }];
  const data = [
    {
      no: 121,
      name: "aswathi",
      type: "textile",
      amt: 200,
      validity: "1 year",
      pDate: "12-12-24",
      expDate: "12-12-24",
      noOfOutlet: 2,
      remaining: 2,
      status: "Active",
    },
  ];

  const params = useParams();
  const [isModify, setIsModify] = useState(false);
  const [addOutlet, setAddOutlet] = useState(false);
  const [openInvoice, setOpenInvoice] = useState(false);
  const [selectedOption, setSelectedOption] = useState();
  const [borderColor, setBorderColor] = useState(getBorderColor(options[0]?.packageName));
  const [isExpand, setIsExpand] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [loadingForm, setLoadingForm] = useState(false);
  const [passwordReset, setPasswordReset] = useState(false);
  const [balancePayment, setBalancePayment] = useState(false);
  const [renewDialog, setRenewDialog] = useState(false);
  const [branchRenewDialog, setBranchRenewDialog] = useState(false);
  const [balanceState, setBalanceState] = useState({ balance: 0, payamount: 0, id: "" });
  const [passwordState, setPasswordState] = useState({ password: "", confirmPassword: "" });
  // License-adjust form state (LEEYET seats). delta: signed integer.
  const [licenseForm, setLicenseForm] = useState({ delta: 1, rate: "", note: "", paid: "" });
  // Settle-balance dialog for a specific licenseHistory entry.
  // `entry` keeps a snapshot of the row being settled (for the readout).
  const [licensePayDialog, setLicensePayDialog] = useState(false);
  const [licensePayState, setLicensePayState] = useState({
    planId: "",
    historyAt: null,
    historyIndex: -1,
    outstanding: 0,
    amount: "",
    note: "",
    entry: null,
  });
  // Confirm-before-delete state for a licenseHistory row.
  const [licenseDeleteDialog, setLicenseDeleteDialog] = useState(false);
  const [licenseDeleteState, setLicenseDeleteState] = useState({
    planId: "",
    historyAt: null,
    historyIndex: -1,
    entry: null,
  });
  const [snackBarStates, setSnackBarStates] = useState({
    success: false,
    error: false,
    message: "",
    alert: false,
  });
  const toIsoDate = (dateObj) => dateObj.toISOString().slice(0, 10);

  const resolveIsoDate = (value) => {
    if (!value) return today;
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return today;
    return toIsoDate(parsed);
  };

  const getStartDateFromExpiry = (expiryValue) => {
    if (!expiryValue) return today;
    const expiry = new Date(expiryValue);
    if (Number.isNaN(expiry.getTime())) return today;
    return expiry.getTime() > Date.now() ? toIsoDate(expiry) : today;
  };

  const addOneYear = (dateValue) => {
    const base = new Date(dateValue || today);
    if (Number.isNaN(base.getTime())) {
      return today;
    }
    base.setFullYear(base.getFullYear() + 1);
    return toIsoDate(base);
  };

  const buildDefaultRenewRange = (expiryValue) => {
    const baseExpiryIso = expiryValue ? resolveIsoDate(expiryValue) : "";
    const start = getStartDateFromExpiry(expiryValue);
    const end = baseExpiryIso ? addOneYear(baseExpiryIso) : addOneYear(start);
    return { start, end, baseExpiry: baseExpiryIso };
  };

  const [renewState, setRenewState] = useState({
    amount: 0,
    startDate: today,
    endDate: today,
    manualEndDate: false,
    planId: "",
    packageId: "",
    baseExpiry: "",
  });
  const [branchRenewState, setBranchRenewState] = useState({
    amount: 0,
    startDate: today,
    endDate: today,
    manualEndDate: false,
    planId: "",
    packageId: "",
    pk: "",
    outletName: "",
    baseExpiry: "",
  });

  const handlePlanAmountChange = (value) => {
    setRenewState((prev) => ({ ...prev, amount: value }));
  };

  const handlePlanStartDateChange = (value) => {
    const start = resolveIsoDate(value);
    setRenewState((prev) => {
      const autoEnd = prev.manualEndDate
        ? resolveIsoDate(prev.endDate)
        : addOneYear(prev.baseExpiry || start);
      return {
        ...prev,
        startDate: start,
        endDate: autoEnd,
      };
    });
  };

  const handlePlanEndDateChange = (value) => {
    const end = resolveIsoDate(value);
    setRenewState((prev) => ({
      ...prev,
      endDate: end,
      manualEndDate: true,
    }));
  };

  const resetPlanEndDate = () => {
    setRenewState((prev) => {
      const nextEnd = addOneYear(prev.baseExpiry || prev.startDate || today);
      return {
        ...prev,
        endDate: nextEnd,
        manualEndDate: false,
      };
    });
  };

  const handleBranchAmountChange = (value) => {
    setBranchRenewState((prev) => ({ ...prev, amount: value }));
  };

  const handleBranchStartDateChange = (value) => {
    const start = resolveIsoDate(value);
    setBranchRenewState((prev) => {
      const autoEnd = prev.manualEndDate
        ? resolveIsoDate(prev.endDate)
        : addOneYear(prev.baseExpiry || start);
      return {
        ...prev,
        startDate: start,
        endDate: autoEnd,
      };
    });
  };

  const handleBranchEndDateChange = (value) => {
    const end = resolveIsoDate(value);
    setBranchRenewState((prev) => ({
      ...prev,
      endDate: end,
      manualEndDate: true,
    }));
  };

  const resetBranchEndDate = () => {
    setBranchRenewState((prev) => {
      const nextEnd = addOneYear(prev.baseExpiry || prev.startDate || today);
      return {
        ...prev,
        endDate: nextEnd,
        manualEndDate: false,
      };
    });
  };

  const closeSnackbar = () => {
    setSnackBarStates({
      ...snackBarStates,
      success: false,
      error: false,
      alert: false,
      message: "",
    });
  };

  const updateListner = () => {
    setIsModify(!isModify);
  };

  const { registeredUserSingle } = params; //Destructur

  useEffect(() => {
    getSingleCustomer({ _id: singleViewId }, setLoadingForm);
  }, [isModify]);

  useEffect(() => {
    setBorderColor(getBorderColor(selectedOption));
  }, [selectedOption]);

  const handleOptionClick = (option) => {
    setSelectedOption(option?.packageName);
  };

  function getBorderColor(type) {
    switch (type) {
      case "ERP-Textile":
        return "#e15871";
      case "ERP-Supermarket":
        return "blue";
      default:
        return "white"; // Default color if type is not recognized
    }
  }

  const clickDownArrow = (index) => {
    setIsExpand(index);
  };

  const clickUpArrow = () => {
    setIsExpand(null);
  };

  const clickBalanceButton = (data) => {
    setBalancePayment(true);
    setBalanceState({
      ...balanceState,
      balance: data?.balance,
      id: data?._id,
    });
  };

  const clickBlanceSubmitFn = () => {
    balancePaymentAPICall(
      {
        paidAmount: Number(balanceState?.payamount),
        _id: balanceState?.id,
      },
      setLoadingForm,
      setSnackBarStates,
      snackBarStates,
      setBalancePayment,
      updateListner
    );
  };

  const suspendUserFn = (data) => {
    console.log(data);
    suspendUserApiCall({
      cusId: singleViewId,
      date: `${today} ${currentTime}`,
      planId: data?.planId,
    });
  };

  const passwordChange = (key) => (e) => {
    setPasswordState({ ...passwordState, [key]: e.target.value });
  };

  const passwordResetBtnFunction = () => {
    if (passwordState?.password !== passwordState?.confirmPassword) {
      alert("password and confirmation do not match.");
    } else {
      resetPasswordAPICall(
        {
          password: passwordState?.confirmPassword,
          _id: singleViewId,
        },
        setSnackBarStates,
        snackBarStates,
        setPasswordReset
      );
    }
  };

  const openInvoiceFn = (data) => {
    viewInvoiceOfCustomer(
      { _id: data?._id },
      setOpenInvoice,
      setSnackBarStates,
      snackBarStates
    );
  };

  const clickAddOutlet = () => {
    console.log("aa");
    // Store planId (purchase ID) for adding outlet, and packageId for fetching package details
    localStorage.setItem("packageId", filteredData[0]?._id);  // Package template ID for fetching details
    localStorage.setItem("planId", filteredData[0]?.planId);  // Purchase/plan ID for backend
    navigate("/dashboard/customerRegistration/cart");
  };

  useEffect(() => {
    if (getSingleCustomers !== undefined) {
      setSelectedOption(getSingleCustomers?.packageList[0]?.packageName);
    }
  }, [getSingleCustomers]);

  useEffect(() => {
    let data = getSingleCustomers?.packageList?.filter((obj) => {
      if (obj?.packageName === selectedOption) {
        return obj;
      }
    });
    setFilteredData(data);
  }, [selectedOption, getSingleCustomers]);

  const openRenewDialog = (pkg) => {
    const { start, end, baseExpiry } = buildDefaultRenewRange(pkg?.expiryDate);
    setRenewState({
      planId: pkg?.planId,
      packageId: pkg?._id,
      amount: pkg?.amount || 0,
      startDate: start,
      endDate: end,
      manualEndDate: false,
      baseExpiry,
    });
    setRenewDialog(true);
  };

  const openBranchRenewDialog = (pkg, outlet) => {
    const { start, end, baseExpiry } = buildDefaultRenewRange(outlet?.expiryDate);
    setBranchRenewState({
      amount: outlet?.amount || pkg?.outletPrice || 0,
      startDate: start,
      endDate: end,
      manualEndDate: false,
      planId: pkg?.planId,
      packageId: pkg?._id,
      pk: outlet?.pk,
      outletName: outlet?.outletName,
      baseExpiry,
    });
    setBranchRenewDialog(true);
  };

  const submitRenewPackage = () => {
    if (!renewState?.planId) {
      setSnackBarStates({ ...snackBarStates, error: true, message: "Plan not found" });
      return;
    }
    const payload = {
      cusId: singleViewId,
      planId: renewState.planId,
      packageId: renewState.packageId,
      totalAmount: Number(renewState.amount) || 0,
      fromDate: `${renewState.startDate} 00:00:00`,
      endDate: `${renewState.endDate} 23:59:59`,
    };
    renewPackageManualAPICall(
      payload,
      setLoadingForm,
      setSnackBarStates,
      snackBarStates,
      () => {
        setRenewDialog(false);
        updateListner();
      }
    );
  };

  const submitRenewBranch = () => {
    if (!branchRenewState?.planId || !branchRenewState?.pk) {
      setSnackBarStates({
        ...snackBarStates,
        error: true,
        message: "Outlet details not found",
      });
      return;
    }
    const payload = {
      cusId: singleViewId,
      planId: branchRenewState.planId,
      pk: branchRenewState.pk,
      totalAmount: Number(branchRenewState.amount) || 0,
      fromDate: `${branchRenewState.startDate} 00:00:00`,
      endDate: `${branchRenewState.endDate} 23:59:59`,
      isRenew: true,
    };
    renewBranchManualAPICall(
      payload,
      setLoadingForm,
      setSnackBarStates,
      snackBarStates,
      () => {
        setBranchRenewDialog(false);
        updateListner();
      }
    );
  };

  return (
    <>
      {/* <TopContainer  /> */}
      <div className="registered-user-header-container">
        <div className="reg-user-name-info-wrapper reg-child">
          <img src={AvatarImg} alt="Avatar Image" />
          <p className="user-name">{getSingleCustomers?.companyName}</p>
          <p className="user-type">{}</p>
          {/* <p className="status-active">Active</p> */}
        </div>
        <div className="reg-user-customer-info-wrapper reg-child">
          <div className="customer-info-child">
            <div className="key">Customer ID</div>
            <div className="value">: {getSingleCustomers?.cusId}</div>
          </div>
          <div className="customer-info-child">
            <div className="key">Customer Name</div>
            <div className="value">: {getSingleCustomers?.customerName}</div>
          </div>
        </div>
        <div className="reg-user-package-info-wrapper reg-child">
          <div className="package-info-sub">
            <div className="key">Contact</div>
            <div className="value">: {getSingleCustomers?.contact}</div>
          </div>
          <div className="package-info-sub">
            <div className="key">Email</div>
            <div className="value">: {getSingleCustomers?.email}</div>
          </div>
        </div>
      </div>

      {/* <div className="registered-user-single-table-container">
        <div style={{display:"flex",justifyContent:"space-between"}}>
           <h3 style={{margin:"0 2%"}}>Package List</h3>
           <button onClick={()=>setAddOutlet(true)} className="global-button-contained-blue-royal">Add Outlets</button>
        </div>
        <div className="global-container-table">
          <table>
            <thead>
              <tr>
                <th>Package</th>
                <th>Amount</th>
                <th>Active Date</th>
                <th>End Date</th>
                <th>Status</th>
                <th>invoice</th>
                <th>View</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>ERP Accounting</td>
                <td>1300</td>
                <td>05-05-2022</td>
                <td>10-05-022</td>
                <td>
                  <p className="active">Active</p>
                </td>
                <td>
                 <Tooltip title="Print Invoice">
                      <IconButton
                              onClick={()=>setOpenInvoice(true)}
                              sx={{ width: "37px", height: "40px" }}
                            >
                              <img
                                style={{ width: "100%" }}
                                src={printImage}
                                alt=""
                              />
                            </IconButton>
                          </Tooltip>
                </td>
                <td><IconButton><VisibilityOutlined sx={{ color: "#83a62f" }}/></IconButton></td>
                <td><IconButton> <DeleteOutlineOutlinedIcon sx={{ color: "#fd0301" }} /></IconButton></td>
              </tr>
            
            </tbody>
          </table>
        </div>
      </div> */}

      {/* <div className="registered-user-single-table-container">
        <div style={{display:"flex",justifyContent:"space-between"}}>
           <h3 style={{margin:"0 2%"}}>Added Outlets</h3>
           <h3 style={{margin:"0 2%",color:"red",fontSize:"0.8rem"}}>Total Outlets 03</h3>
        </div>
          
           <div className="global-container-table">
          <table>
            <thead>
              <tr>
                <th>No</th>
                <th>Outlet Name</th>
                <th>Active Date</th>
                <th>End Date</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>01</td>
                <td>abc</td>
                <td>05-05-2022</td>
                <td>10-05-022</td>
                <td>
                  <p>Active</p>
                </td>
                <td>
                  <span style={{backgroundColor:"rgb(74 13 183)",color:"#fff",padding:"2% 8%",cursor:"pointer"}}>Renew</span>
                </td>
              </tr>
             
            </tbody>
          </table>
        </div>
      </div> */}

      <div className="single-user-bottom-container">
        <div className="single-user-first-container">
          {getSingleCustomers?.packageList?.map((obj) => (
            <div
              className={"single-user-top-single-card"}
              onClick={() => handleOptionClick(obj)}
              style={{
                borderColor: selectedOption === obj.packageName ? obj?.hexCode : "white",
              }}
            >
              <div
                className="single-user-top-single-card-image"
                style={{ backgroundColor: obj?.hexCode }}
              >
                <img src={`data:name;base64,${obj?.logo?.data}`} alt="" />
              </div>
              <p>{obj?.packageName}</p>
            </div>
          ))}
        </div>
        <div className="single-user-second-container">
          <p className="package-label">PACKAGE</p>
          <div
            className="new-global-table-container"
            style={{ backgroundColor: "#eef1f9" }}
          >
            <table>
              <thead>
                <tr>
                  <th>Package No</th>
                  <th>Com Code</th>
                  <th>Customer</th>
                  <th>Package Type</th>
                  <th>Amount</th>
                  <th>Validity</th>
                  <th>Purchase Date</th>
                  <th>Expiry Date</th>
                  <th>No Of Outlet</th>
                  <th>Remaining Outlet</th>
                  <th>Status</th>
                  <th>
                    <p style={{ fontSize: "0.7rem", color: "#11cd11" }}>
                      Active/
                      <span style={{ fontSize: "0.7rem", color: "red" }}>Suspend</span>
                    </p>
                  </th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {filteredData !== undefined && filteredData?.length !== 0 ? (
                  filteredData?.map((r, i) => (
                    <>
                      <tr>
                        <td>{r?.packageId}</td>
                        <td>{r?.companyCode || "--"}</td>
                        <td>{r?.packageName}</td>
                        <td>{r?.packageType}</td>
                        <td>{r?.amount}</td>
                        <td>{r?.validity}</td>
                        <td>{r?.purchaseDate}</td>
                        <td>{r?.expiryDate}</td>
                        <td>{r?.noOfOutlets}</td>
                        <td>{r?.remainingOutlets}</td>
                        <td>
                          <p
                            className={
                              r?.status === "Refund Completed"
                                ? "status-pakg-refund"
                                : r?.status === "active"
                                ? "status-active"
                                : r?.status === "expired"
                                ? "status-pakg-expired"
                                : undefined
                            }
                          >
                            {r?.status?.toUpperCase()}
                          </p>
                        </td>
                        <td>
                          <input
                            className="toggle-checkbox"
                            type={"checkbox"}
                            checked={r?.status === "active" ? true : false}
                            onChange={() => suspendUserFn(r)}
                            name="customerAll"
                          />
                        </td>
                        <td>
                          {isExpand === null ? (
                            <IconButton onClick={() => clickDownArrow(i)}>
                              <i class="bi bi-arrow-down"></i>
                            </IconButton>
                          ) : (
                            <IconButton onClick={() => clickUpArrow()}>
                              <i class="bi bi-arrow-up"></i>
                            </IconButton>
                          )}
                        </td>
                        <td>
                          <i
                            onClick={() => setPasswordReset(true)}
                            class="bi bi-lock"
                            style={{
                              color: "#500299",
                              fontSize: "1rem",
                              backgroundColor: "#e9d7fa",
                              padding: "4px",
                              marginRight: "6px",
                            }}
                          ></i>
                          <button
                            className="global-button-contained-blue"
                            style={{ padding: "4px 12px", fontSize: "0.7rem" }}
                            onClick={() => openRenewDialog(r)}
                          >
                            Renew
                          </button>
                        </td>
                      </tr>
                      {isExpand === i && (
                        <tr>
                          <td colSpan={14}>
                            <div
                              className="new-global-table-container"
                              style={{
                                backgroundColor: "#eef1f9",
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <table style={{ width: "90%" }}>
                                <thead>
                                  <tr>
                                    <th>TXN</th>
                                    <th>TXN Date</th>
                                    {/* <th>Customer</th> */}
                                    <th>TXN Expiry Date</th>
                                    {/* <th>TXN Validity</th> */}
                                    <th>Status</th>
                                    <th>Amount</th>
                                    <th>Paid</th>
                                    <th>Balance</th>
                                    <th></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {r?.transactions?.map((k, i) => (
                                    <tr key={i}>
                                      <td>{k?.purchaseId}</td>
                                      <td>{k?.txnDate}</td>
                                      {/* <td>--</td> */}
                                      <td>{k?.txnExpDate}</td>
                                      {/* <td>--</td> */}
                                      <td>
                                        <p
                                          style={{
                                            fontSize: "0.8rem",
                                            fontWeight: 600,
                                            color: "#0ac30a",
                                          }}
                                        >
                                          {k?.status?.toUpperCase()}
                                        </p>
                                      </td>
                                      <td>{k?.amount}</td>
                                      <td>{k?.paidAmount}</td>
                                      <td>
                                        {k?.balance > 0 ? (
                                          <p
                                            onClick={() => clickBalanceButton(k)}
                                            title="Pay"
                                            style={{
                                              backgroundColor: "blue",
                                              padding: "2px",
                                              borderRadius: "4px",
                                              color: "#fff",
                                            }}
                                          >
                                            {k?.balance}
                                          </p>
                                        ) : (
                                          <p>{k?.balance}</p>
                                        )}
                                      </td>
                                      <td>
                                        <img
                                          onClick={() => openInvoiceFn(k)}
                                          title="Invoice"
                                          src={invoice}
                                          alt=""
                                          style={{ width: "35px", height: "35px" }}
                                        />
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                      )}
                    </>
                  ))
                ) : (
                  <tr>
                    <td colSpan={11}>No Data</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        {/* License Management panel for LEEYET (or any per-seat) plans */}
        {(() => {
          const active = filteredData && filteredData[0];
          if (!active) return null;
          const isLeeyet =
            active.erpType === "ERP-LEEYET" ||
            active.erpType === "ERP-HOSPITALITY" ||
            !!active.bundleCode ||
            (typeof active.packageName === "string" && active.packageName.toLowerCase().includes("leeyet"));
          if (!isLeeyet) return null;
          const qty = Number(active.licenseQty) || 0;
          const rate = Number(active.licenseRate) || 0;
          const delta = Number(licenseForm.delta) || 0;
          const overrideRate =
            licenseForm.rate !== "" && licenseForm.rate !== null && licenseForm.rate !== undefined
              ? Number(licenseForm.rate)
              : rate;
          const flatImpact = delta * overrideRate;
          // Pro-rate the seat-cost over the remaining portion of the active
          // billing cycle. Pulls cycle bounds from the plan's purchase/expiry
          // fields (whichever shape the view returns). Falls back to factor=1
          // when the dates can't be parsed.
          const _parseTs = (v) => {
            if (!v) return NaN;
            const n = typeof v === "number" ? v : Date.parse(v);
            return isNaN(n) ? NaN : n;
          };
          const purchaseTs = _parseTs(active.purchaseDate);
          const expiryTs   = _parseTs(active.expiryDate);
          const nowTs      = Date.now();
          const cycleMs    = expiryTs > purchaseTs ? (expiryTs - purchaseTs) : 0;
          const remainMs   = expiryTs > nowTs ? (expiryTs - nowTs) : 0;
          const dayMs      = 24 * 60 * 60 * 1000;
          const prorationFactor = cycleMs > 0
            ? Math.max(0, Math.min(1, remainMs / cycleMs))
            : 1;
          const proratedImpact = Math.round(flatImpact * prorationFactor * 100) / 100;
          const daysRemaining  = Math.round(remainMs / dayMs);
          const cycleDays      = Math.round(cycleMs / dayMs);
          const totalImpact    = proratedImpact;
          const submitAdjust = () => {
            if (!active.planId || !delta) return;
            adjustLicenseAPICall(
              {
                planId: active.planId,
                delta,
                ratePerSeat:
                  licenseForm.rate !== "" && licenseForm.rate !== null && licenseForm.rate !== undefined
                    ? Number(licenseForm.rate)
                    : undefined,
                paidAmount:
                  licenseForm.paid !== "" && licenseForm.paid !== null && licenseForm.paid !== undefined
                    ? Number(licenseForm.paid)
                    : 0,
                note: licenseForm.note || "",
              },
              singleViewId,
              setLoadingForm,
              setSnackBarStates,
              snackBarStates
            );
            setLicenseForm({ delta: 1, rate: "", note: "", paid: "" });
          };
          return (
            <div className="single-user-second-container" style={{ marginTop: 16 }}>
              <p className="package-label" style={{ color: "#4c1d95" }}>
                License Management ({active.packageName})
              </p>
              <div
                className="new-global-table-container"
                style={{ backgroundColor: "#f5f0ff", padding: 12, borderRadius: 8 }}
              >
                <div style={{ display: "flex", gap: 24, flexWrap: "wrap", alignItems: "center" }}>
                  <div>
                    <p style={{ fontSize: "0.75rem", color: "#6b7280", margin: 0 }}>Current Seats</p>
                    <p style={{ fontSize: "1.4rem", fontWeight: 700, margin: 0, color: "#4c1d95" }}>{qty}</p>
                  </div>
                  <div>
                    <p style={{ fontSize: "0.75rem", color: "#6b7280", margin: 0 }}>Per-seat Rate</p>
                    <p style={{ fontSize: "1.1rem", fontWeight: 600, margin: 0 }}>{rate}</p>
                  </div>
                  <div style={{ flex: 1, minWidth: 240 }}>
                    <p style={{ fontSize: "0.75rem", color: "#6b7280", margin: 0 }}>Adjustment Impact</p>
                    <p style={{ fontSize: "0.9rem", margin: 0 }}>
                      New seats: <b>{Math.max(0, qty + delta)}</b> &nbsp;|&nbsp; Pro-rated charge:{" "}
                      <b style={{ color: totalImpact >= 0 ? "#059669" : "#dc2626" }}>{totalImpact}</b>
                    </p>
                    {cycleDays > 0 && (
                      <p style={{ fontSize: "0.7rem", color: "#6b7280", margin: "2px 0 0 0" }}>
                        {daysRemaining}/{cycleDays} days remain &middot; factor {(prorationFactor * 100).toFixed(1)}% &middot; flat would be <b>{flatImpact}</b>
                      </p>
                    )}
                  </div>
                </div>
                <div style={{ display: "flex", gap: 12, marginTop: 12, flexWrap: "wrap", alignItems: "flex-end" }}>
                  <div className="global-single-input" style={{ width: 120 }}>
                    <p>Delta (+/-)</p>
                    <input
                      type="number"
                      step="1"
                      value={licenseForm.delta}
                      onChange={(e) => setLicenseForm({ ...licenseForm, delta: e.target.value })}
                    />
                  </div>
                  <div style={{ display: "flex", gap: 4 }}>
                    <button
                      type="button"
                      className="global-button-contained-blue"
                      style={{ padding: "6px 10px", fontSize: "0.75rem" }}
                      onClick={() => setLicenseForm({ ...licenseForm, delta: Math.abs(Number(licenseForm.delta) || 1) })}
                      title="Add seats"
                    >
                      + Add
                    </button>
                    <button
                      type="button"
                      className="global-button-contained-blue"
                      style={{ padding: "6px 10px", fontSize: "0.75rem", background: "#dc2626" }}
                      onClick={() => setLicenseForm({ ...licenseForm, delta: -Math.abs(Number(licenseForm.delta) || 1) })}
                      title="Remove seats"
                    >
                      - Remove
                    </button>
                  </div>
                  <div className="global-single-input" style={{ width: 160 }}>
                    <p>Override rate (optional)</p>
                    <input
                      type="number"
                      step="0.01"
                      placeholder={String(rate)}
                      value={licenseForm.rate}
                      onChange={(e) => setLicenseForm({ ...licenseForm, rate: e.target.value })}
                    />
                  </div>
                  <div className="global-single-input" style={{ width: 140 }}>
                    <p>Paid amount</p>
                    <input
                      type="number"
                      step="0.01"
                      placeholder={String(totalImpact || 0)}
                      value={licenseForm.paid}
                      onChange={(e) => setLicenseForm({ ...licenseForm, paid: e.target.value })}
                    />
                  </div>
                  <div className="global-single-input" style={{ flex: 1, minWidth: 200 }}>
                    <p>Note</p>
                    <input
                      type="text"
                      placeholder="Reason / PO ref"
                      value={licenseForm.note}
                      onChange={(e) => setLicenseForm({ ...licenseForm, note: e.target.value })}
                    />
                  </div>
                  <button
                    type="button"
                    className="global-button-contained-blue"
                    style={{ padding: "8px 16px" }}
                    onClick={submitAdjust}
                    disabled={!delta || !active.planId}
                  >
                    Apply
                  </button>
                </div>

                {Array.isArray(active.licenseHistory) && active.licenseHistory.length > 0 && (
                  <div style={{ marginTop: 16 }}>
                    <p style={{ fontSize: "0.75rem", color: "#6b7280", margin: "0 0 4px" }}>
                      Recent adjustments
                    </p>
                    <table style={{ width: "100%", fontSize: "0.8rem" }}>
                      <thead>
                        <tr>
                          <th style={{ textAlign: "left" }}>Date</th>
                          <th>Delta</th>
                          <th>Qty After</th>
                          <th>Rate</th>
                          <th>Total</th>
                          <th>Paid</th>
                          <th>Balance</th>
                          <th>By</th>
                          <th style={{ textAlign: "left" }}>Note</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {[...active.licenseHistory]
                          .map((h, srcIdx) => ({ h, srcIdx }))
                          .reverse()
                          .slice(0, 8)
                          .map(({ h, srcIdx }) => (
                            <tr key={h.at || srcIdx}>
                              <td>{h.at ? new Date(h.at).toLocaleString() : "-"}</td>
                              <td style={{ textAlign: "center", color: h.delta >= 0 ? "#059669" : "#dc2626" }}>
                                {h.delta > 0 ? `+${h.delta}` : h.delta}
                              </td>
                              <td style={{ textAlign: "center" }}>{h.qty}</td>
                              <td style={{ textAlign: "center" }}>{h.rate}</td>
                              <td style={{ textAlign: "center" }}>{h.total}</td>
                              <td style={{ textAlign: "center" }}>{Number(h.paid) || 0}</td>
                              <td
                                style={{
                                  textAlign: "center",
                                  color:
                                    Number(h.balance) > 0
                                      ? "#dc2626"
                                      : Number(h.balance) < 0
                                      ? "#059669"
                                      : "inherit",
                                  fontWeight: Number(h.balance) !== 0 ? 600 : 400,
                                }}
                              >
                                {Number(h.balance) || 0}
                              </td>
                              <td style={{ textAlign: "center" }}>{h.by || "admin"}</td>
                              <td>{h.note || ""}</td>
                              <td style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                                {Number(h.balance) !== 0 ? (
                                  <button
                                    type="button"
                                    className="global-button-contained-blue"
                                    style={{ padding: "4px 10px", fontSize: "0.72rem" }}
                                    onClick={() => {
                                      const outstanding = Math.abs(Number(h.balance) || 0);
                                      setLicensePayState({
                                        planId: active.planId,
                                        historyAt: Number(h.at) || null,
                                        historyIndex: srcIdx,
                                        outstanding,
                                        amount: String(outstanding),
                                        note: "",
                                        entry: h,
                                      });
                                      setLicensePayDialog(true);
                                    }}
                                  >
                                    {Number(h.balance) > 0 ? "Pay" : "Refund"}
                                  </button>
                                ) : (
                                  <span style={{ color: "#059669", fontSize: "0.72rem" }}>Settled</span>
                                )}
                                <Tooltip title="Delete adjustment (reverts seats)">
                                  <IconButton
                                    size="small"
                                    style={{ marginLeft: 4, padding: 4 }}
                                    onClick={() => {
                                      setLicenseDeleteState({
                                        planId: active.planId,
                                        historyAt: Number(h.at) || null,
                                        historyIndex: srcIdx,
                                        entry: h,
                                      });
                                      setLicenseDeleteDialog(true);
                                    }}
                                  >
                                    <DeleteOutlineOutlinedIcon
                                      fontSize="small"
                                      style={{ color: "#dc2626" }}
                                    />
                                  </IconButton>
                                </Tooltip>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          );
        })()}

        <div className="single-user-second-container">
          <div className="package-label">
            <p>Outlets</p>
            <p
              onClick={clickAddOutlet}
              style={{
                fontSize: "0.7rem",
                color: "blue",
                fontWeight: 500,
                margin: "2px 0 0 16px",
                cursor: "pointer",
              }}
            >
              Add Outlet
            </p>
          </div>

          <div
            className="new-global-table-container"
            style={{ backgroundColor: "#eef1f9" }}
          >
            <table>
              <thead>
                <tr>
                  <th>Outlet Name</th>
                  <th>country</th>
                  <th>Package</th>
                  <th>Type</th>
                  <th>Outlet Purchase Date</th>
                  <th>Outlet Expiry Date</th>
                  <th>Status</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {filteredData !== undefined && filteredData[0]?.outletList?.length !== 0 ? (
                  // (See License Management panel above for LEEYET seat controls)
                  filteredData[0]?.outletList?.map((r, i) => (
                    <tr>
                      <td>{r?.outletName}</td>
                      <td>{r?.country}</td>
                      <td>{r?.packageName}</td>
                      <td>{r?.packageType}</td>
                      <td>{r?.purchaseDate}</td>
                      <td>{r?.expiryDate}</td>
                      <td>
                        <p
                          className={
                            r?.status === "Refund Completed"
                              ? "status-pakg-refund"
                              : r?.status === "active"
                              ? "status-active"
                              : r?.status === "expired"
                              ? "status-pakg-expired"
                              : undefined
                          }
                        >
                          {r?.status?.toUpperCase()}
                        </p>
                      </td>
                      <td
                        style={{
                          background: "none",
                          borderBottom: "none",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <div
                          className="go-to-website"
                          style={{ backgroundColor: "blue", opacity: r?.status === "expired" || r?.status === "active" ? 1 : 0.6 }}
                          onClick={() => openBranchRenewDialog(filteredData[0], r)}
                        >
                          <i class="bi bi-arrow-repeat"></i>
                          <p>Renew</p>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={8}>No Data</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <Dialog open={addOutlet} maxWidth="lg">
        <div className="register-form-container" style={{ width: "50vw" }}>
          <div style={{ padding: "12px" }}>
            <h4>Add Outlet Qty</h4>
            <p
              style={{
                color: "red",
                fontSize: "0.8rem",
                fontWeight: 500,
                margin: "4px 0",
              }}
            >
              *Purchase Outlets -2
            </p>
            <hr />
            <div style={{ display: "flex" }}>
              <div
                className="global-single-input auto-complete"
                style={{ width: "20%" }}
              >
                <p>Qty</p>
                <input type="text" />
              </div>
              <div
                className="global-single-input auto-complete"
                style={{ width: "30%" }}
              >
                <p>Outlet Price</p>
                <input type="text" />
              </div>
              <div
                className="global-single-input auto-complete"
                style={{ width: "30%" }}
              >
                <p>Discount(%)</p>
                <input type="text" />
              </div>
              <div
                className="global-single-input auto-complete"
                style={{ width: "30%" }}
              >
                <p>Total Price</p>
                <input type="text" />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                margin: "8px 2px",
              }}
            >
              <button onClick={() => setAddOutlet(false)} className="global-button-contained-black-outlined">
                Cancel
              </button>
              <button className="global-button-contained-blue">Save</button>
            </div>
          </div>
        </div>
      </Dialog>

      {/* invoice */}
      <Dialog open={openInvoice} onClose={() => setOpenInvoice(false)} maxWidth="lg">
        <div style={{ position: "relative", width: "45vw" }}>
          <div ref={(el) => (invoicePrint = el)}>
            <Invoice data={invoiceData} />
          </div>
        </div>

        <div
          id="invoicePrintIcon"
          style={{ position: "fixed", bottom: "25%", left: "47%" }}
        >
          <ReactToPrint
            trigger={() => (
              <IconButton
                className="invoice-print-btn"
                sx={{
                  backgroundColor: "#d3e3ec",
                }}
              >
                <PrintOutlined className="print-icon" sx={{ color: "#000" }} />
              </IconButton>
            )}
            content={() => invoicePrint}
          />
        </div>
      </Dialog>

      {/* password reset */}
      <Dialog open={passwordReset} maxWidth="lg" onClose={() => setPasswordReset(false)}>
        <div className="register-form-container" style={{ width: "25vw" }}>
          <div style={{ padding: "20px" }}>
            <div className="reset-top-container">
              <div className="reset-top-container-icon">
                <i class="bi bi-lock" style={{ color: "#33b166", fontSize: "1rem", padding: "4px" }}></i>
              </div>
              <p>Reset Password</p>
            </div>
            <div className="reset-password-input">
              <p>Password</p>
              <input type="password" value={passwordState?.password} onChange={passwordChange("password")} />
            </div>
            <div className="reset-password-input">
              <p>Confirm Password</p>
              <input type="password" value={passwordState?.confirmPassword} onChange={passwordChange("confirmPassword")} />
            </div>
            <button onClick={passwordResetBtnFunction} className="reset-submit">
              SUBMIT
            </button>
          </div>
        </div>
      </Dialog>

      <Dialog open={balancePayment} maxWidth="lg" onClose={() => setBalancePayment(false)}>
        <div className="register-form-container" style={{ width: "25vw" }}>
          <div style={{ padding: "20px" }}>
            <div className="reset-top-container">
              <p>Pay Balance</p>
            </div>
            <div className="pay-balance-container">
              <p>Balance Amount</p>
              <input type="text" value={balanceState?.balance} />
            </div>
            <div className="pay-balance-container">
              <p>Pay Amount</p>
              <input type="text" value={balanceState?.payamount} onChange={(e) => setBalanceState({ ...balanceState, payamount: e.target.value })} />
            </div>
            <button onClick={clickBlanceSubmitFn} className="reset-submit">
              Pay Balance
            </button>
          </div>
        </div>
      </Dialog>

      {/* License-history balance settlement (per added/removed seat row). */}
      <Dialog
        open={licensePayDialog}
        maxWidth="lg"
        onClose={() => setLicensePayDialog(false)}
      >
        <div className="register-form-container" style={{ width: "28vw" }}>
          <div style={{ padding: "20px" }}>
            <div className="reset-top-container">
              <p>
                {licensePayState.entry && Number(licensePayState.entry.total) < 0
                  ? "Refund Balance"
                  : "Pay Balance"}{" "}
                — Seat Adjustment
              </p>
            </div>
            {licensePayState.entry && (
              <div
                style={{
                  background: "#f5f0ff",
                  padding: 10,
                  borderRadius: 6,
                  fontSize: "0.78rem",
                  marginBottom: 12,
                }}
              >
                <div>
                  <strong>Date:</strong>{" "}
                  {licensePayState.entry.at
                    ? new Date(licensePayState.entry.at).toLocaleString()
                    : "-"}
                </div>
                <div>
                  <strong>Seats:</strong>{" "}
                  {licensePayState.entry.delta > 0
                    ? `+${licensePayState.entry.delta}`
                    : licensePayState.entry.delta}{" "}
                  &nbsp; <strong>Rate:</strong> {licensePayState.entry.rate}
                </div>
                <div>
                  <strong>Total:</strong> {licensePayState.entry.total} &nbsp;
                  <strong>Already Paid:</strong>{" "}
                  {Number(licensePayState.entry.paid) || 0}
                </div>
              </div>
            )}
            <div className="pay-balance-container">
              <p>Outstanding</p>
              <input
                type="text"
                value={licensePayState.outstanding}
                readOnly
                onChange={() => {}}
              />
            </div>
            <div className="pay-balance-container">
              <p>Pay Amount</p>
              <input
                type="number"
                step="0.01"
                value={licensePayState.amount}
                onChange={(e) =>
                  setLicensePayState({ ...licensePayState, amount: e.target.value })
                }
              />
            </div>
            <div className="pay-balance-container">
              <p>Note (optional)</p>
              <input
                type="text"
                value={licensePayState.note}
                placeholder="Receipt / reference"
                onChange={(e) =>
                  setLicensePayState({ ...licensePayState, note: e.target.value })
                }
              />
            </div>
            <button
              onClick={() => {
                const amt = Number(licensePayState.amount);
                if (!licensePayState.planId || !Number.isFinite(amt) || amt <= 0) return;
                payLicenseBalanceAPICall(
                  {
                    planId: licensePayState.planId,
                    historyAt: licensePayState.historyAt,
                    historyIndex: licensePayState.historyIndex,
                    amount: amt,
                    note: licensePayState.note || "",
                  },
                  singleViewId,
                  setLoadingForm,
                  setSnackBarStates,
                  snackBarStates,
                  () => setLicensePayDialog(false)
                );
              }}
              className="reset-submit"
              disabled={
                !licensePayState.planId ||
                !Number(licensePayState.amount) ||
                Number(licensePayState.amount) <= 0
              }
            >
              {licensePayState.entry && Number(licensePayState.entry.total) < 0
                ? "Record Refund"
                : "Pay Balance"}
            </button>
          </div>
        </div>
      </Dialog>

      {/* Confirm-delete dialog for a licenseHistory row. */}
      <Dialog
        open={licenseDeleteDialog}
        maxWidth="lg"
        onClose={() => setLicenseDeleteDialog(false)}
      >
        <div className="register-form-container" style={{ width: "26vw" }}>
          <div style={{ padding: "20px" }}>
            <div className="reset-top-container">
              <p style={{ color: "#dc2626" }}>Delete Seat Adjustment?</p>
            </div>
            {licenseDeleteState.entry && (
              <div
                style={{
                  background: "#fef2f2",
                  border: "1px solid #fecaca",
                  padding: 10,
                  borderRadius: 6,
                  fontSize: "0.78rem",
                  marginBottom: 12,
                }}
              >
                <div>
                  <strong>Date:</strong>{" "}
                  {licenseDeleteState.entry.at
                    ? new Date(licenseDeleteState.entry.at).toLocaleString()
                    : "-"}
                </div>
                <div>
                  <strong>Seats:</strong>{" "}
                  {Number(licenseDeleteState.entry.delta) > 0
                    ? `+${licenseDeleteState.entry.delta}`
                    : licenseDeleteState.entry.delta}{" "}
                  &nbsp; <strong>Rate:</strong> {licenseDeleteState.entry.rate}
                </div>
                <div>
                  <strong>Total:</strong> {licenseDeleteState.entry.total} &nbsp;
                  <strong>Paid:</strong> {Number(licenseDeleteState.entry.paid) || 0} &nbsp;
                  <strong>Balance:</strong> {Number(licenseDeleteState.entry.balance) || 0}
                </div>
                <div style={{ marginTop: 6, color: "#7f1d1d" }}>
                  This will revert{" "}
                  <strong>
                    {Math.abs(Number(licenseDeleteState.entry.delta) || 0)} seat(s)
                  </strong>{" "}
                  ({Number(licenseDeleteState.entry.delta) > 0 ? "remove" : "add back"})
                  and permanently remove this row. Recorded payments on this
                  row will be lost.
                </div>
              </div>
            )}
            <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
              <button
                type="button"
                onClick={() => setLicenseDeleteDialog(false)}
                style={{
                  padding: "8px 16px",
                  borderRadius: 6,
                  border: "1px solid #d1d5db",
                  background: "#fff",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                className="reset-submit"
                style={{ background: "#dc2626", color: "#fff" }}
                onClick={() => {
                  if (!licenseDeleteState.planId) return;
                  deleteLicenseHistoryAPICall(
                    {
                      planId: licenseDeleteState.planId,
                      historyAt: licenseDeleteState.historyAt,
                      historyIndex: licenseDeleteState.historyIndex,
                    },
                    singleViewId,
                    setLoadingForm,
                    setSnackBarStates,
                    snackBarStates,
                    () => setLicenseDeleteDialog(false)
                  );
                }}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </Dialog>

      <Dialog open={renewDialog} maxWidth="sm" onClose={() => setRenewDialog(false)}>
        <div className="register-form-container" style={{ width: "28vw" }}>
          <div style={{ padding: "20px" }}>
            <div className="reset-top-container">
              <p>Renew Package</p>
            </div>
            <div className="pay-balance-container">
              <p>Amount</p>
              <input
                type="number"
                value={renewState.amount}
                onChange={(e) => handlePlanAmountChange(e.target.value)}
              />
            </div>
            <div className="pay-balance-container">
              <p>Start Date</p>
              <input
                type="date"
                value={renewState.startDate}
                onChange={(e) => handlePlanStartDateChange(e.target.value)}
              />
            </div>
            <div className="pay-balance-container">
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <p style={{ marginBottom: 0 }}>Expiry Date</p>
                <button
                  type="button"
                  className="global-button-contained-black-outlined"
                  style={{ padding: "2px 8px", fontSize: "0.65rem" }}
                  onClick={resetPlanEndDate}
                  disabled={!renewState.manualEndDate}
                >
                  Auto +1 year
                </button>
              </div>
              <input
                type="date"
                value={renewState.endDate}
                onChange={(e) => handlePlanEndDateChange(e.target.value)}
              />
              <small style={{ color: "#666" }}>
                Default expiry is set to one year from the selected start date.
              </small>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px", marginTop: "16px" }}>
              <button onClick={() => setRenewDialog(false)} className="global-button-contained-black-outlined">
                Cancel
              </button>
              <button onClick={submitRenewPackage} className="global-button-contained-blue">
                Renew
              </button>
            </div>
          </div>
        </div>
      </Dialog>

      <Dialog open={branchRenewDialog} maxWidth="sm" onClose={() => setBranchRenewDialog(false)}>
        <div className="register-form-container" style={{ width: "28vw" }}>
          <div style={{ padding: "20px" }}>
            <div className="reset-top-container">
              <p>
                Renew Outlet
                {branchRenewState.outletName ? ` - ${branchRenewState.outletName}` : ""}
              </p>
            </div>
            <div className="pay-balance-container">
              <p>Amount</p>
              <input
                type="number"
                value={branchRenewState.amount}
                onChange={(e) => handleBranchAmountChange(e.target.value)}
              />
            </div>
            <div className="pay-balance-container">
              <p>Start Date</p>
              <input
                type="date"
                value={branchRenewState.startDate}
                onChange={(e) => handleBranchStartDateChange(e.target.value)}
              />
            </div>
            <div className="pay-balance-container">
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <p style={{ marginBottom: 0 }}>Expiry Date</p>
                <button
                  type="button"
                  className="global-button-contained-black-outlined"
                  style={{ padding: "2px 8px", fontSize: "0.65rem" }}
                  onClick={resetBranchEndDate}
                  disabled={!branchRenewState.manualEndDate}
                >
                  Auto +1 year
                </button>
              </div>
              <input
                type="date"
                value={branchRenewState.endDate}
                onChange={(e) => handleBranchEndDateChange(e.target.value)}
              />
              <small style={{ color: "#666" }}>
                Default expiry is set to one year from the selected start date.
              </small>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px", marginTop: "16px" }}>
              <button onClick={() => setBranchRenewDialog(false)} className="global-button-contained-black-outlined">
                Cancel
              </button>
              <button onClick={submitRenewBranch} className="global-button-contained-blue">
                Renew Outlet
              </button>
            </div>
          </div>
        </div>
      </Dialog>

      <LoadingForm loading={loadingForm} />
      <SuccessSnackbar
        open={snackBarStates.success}
        handleClose={closeSnackbar}
        message={snackBarStates.message}
      />
      <ErrorSnackbar
        open={snackBarStates.error}
        handleClose={closeSnackbar}
        message={snackBarStates.message}
      />
    </>
  );
};

export default RegisteredUserSingle;
